import { N as push, O as setContext, _ as spread_attributes, $ as clsx, a0 as bind_props, P as pop, a1 as spread_props, a2 as copy_payload, a3 as assign_payload, a4 as ensure_array_like, a5 as store_get, T as escape_html, a6 as attr, a7 as stringify, a8 as unsubscribe_stores, R as slot } from "../../../../chunks/index.js";
import { C as ClassAdder, G as Graphic, T as Text, I as IconButton } from "../../../../chunks/Graphic.js";
import "clsx";
import { p as page, D as DownloadButton } from "../../../../chunks/stores.js";
import { A as Animate } from "../../../../chunks/Animate.js";
import { o as onDestroy } from "../../../../chunks/index-server.js";
import { c as classMap, S as SvelteEventManager, a as SmuiElement, d as dispatch, L as List, I as Item } from "../../../../chunks/Menu.js";
import { S as Separator } from "../../../../chunks/Separator.js";
import { L as Link } from "../../../../chunks/Link.js";
import { L as Logo } from "../../../../chunks/Logo.js";
import { c as PUBLIC_INSTALLER_NAME } from "../../../../chunks/public.js";
import { a as analytics } from "../../../../chunks/analytics.js";
import { g as goto } from "../../../../chunks/client.js";
import { P as PurchaseButton } from "../../../../chunks/PurchaseButton.js";
function Drawer($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    variant,
    open = false,
    fixed = true,
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let eventManager = new SvelteEventManager();
  let internalClasses = {};
  setContext("SMUI:list:nav", true);
  setContext("SMUI:list:item:nav", true);
  setContext("SMUI:list:wrapFocus", true);
  onDestroy(() => {
    eventManager.clear();
  });
  function setOpen(value) {
    open = value;
  }
  function isOpen() {
    return open;
  }
  function getElement() {
    return element;
  }
  $$payload.out += `<aside${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-drawer": true,
      "mdc-drawer--dismissible": variant === "dismissible",
      "mdc-drawer--modal": variant === "modal",
      "smui-drawer__absolute": variant === "modal" && !fixed,
      ...internalClasses
    })),
    ...restProps
  })}>`;
  children?.($$payload);
  $$payload.out += `<!----></aside>`;
  bind_props($$props, { open, setOpen, isOpen, getElement });
  pop();
}
function AppContent($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    {
      _smuiClass: "mdc-drawer-app-content",
      tag: "div"
    },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Content($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    { _smuiClass: "mdc-drawer__content", tag: "div" },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Header($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    { _smuiClass: "mdc-drawer__header", tag: "div" },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Scrim($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    fixed = true,
    component: MyComponent = SmuiElement,
    tag = "div",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  function handleClick(event) {
    dispatch(getElement(), "SMUIDrawerScrimClick", event);
  }
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use,
      class: classMap({
        [className]: true,
        "mdc-drawer-scrim": true,
        "smui-drawer-scrim__absolute": !fixed
      })
    },
    restProps,
    {
      onclick: (e) => {
        handleClick(e);
        restProps.onclick?.(e);
      },
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { getElement });
  pop();
}
const trackDownload = (platform, version) => {
  analytics.track("download", { platform, version });
};
const openLink = (href, download) => {
  const link = document.createElement("a");
  link.href = href;
  link.download = download;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const downloadInstaller = () => {
  const url = "/releases/latest/glimmr-setup.exe";
  trackDownload("windows", "latest");
  openLink(url, PUBLIC_INSTALLER_NAME);
};
const menu = [
  {
    name: "Features",
    link: "/features",
    icon: "star"
  },
  {
    name: "Pricing",
    link: "/pricing",
    icon: "sell"
  },
  {
    name: "Support",
    link: "/support",
    icon: "support"
  },
  {
    name: "Portal",
    link: "/portal",
    icon: "person"
  }
];
function Navbar($$payload, $$props) {
  push();
  var $$store_subs;
  let open = false;
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    const each_array_1 = ensure_array_like(menu);
    Drawer($$payload2, {
      class: "z-[100]",
      variant: "modal",
      get open() {
        return open;
      },
      set open($$value) {
        open = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        Header($$payload3, {
          class: "flex items-center justify-center py-12",
          children: ($$payload4) => {
            Logo($$payload4);
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!----> `;
        Separator($$payload3, {});
        $$payload3.out += `<!----> `;
        Content($$payload3, {
          class: "flex flex-col",
          children: ($$payload4) => {
            List($$payload4, {
              class: "flex-1",
              children: ($$payload5) => {
                const each_array = ensure_array_like(menu);
                $$payload5.out += `<!--[-->`;
                for (let i = 0, $$length = each_array.length; i < $$length; i++) {
                  let { name, link, icon } = each_array[i];
                  const active = store_get($$store_subs ??= {}, "$page", page).url.href.replace(store_get($$store_subs ??= {}, "$page", page).url.origin, "") === link;
                  Item($$payload5, {
                    href: "javascript:void(0)",
                    onclick: () => goto(),
                    activated: active,
                    children: ($$payload6) => {
                      Graphic($$payload6, {
                        class: "material-symbols-outlined",
                        children: ($$payload7) => {
                          $$payload7.out += `<!---->${escape_html(icon)}`;
                        },
                        $$slots: { default: true }
                      });
                      $$payload6.out += `<!----> `;
                      Text($$payload6, {
                        children: ($$payload7) => {
                          $$payload7.out += `<!---->${escape_html(name)}`;
                        },
                        $$slots: { default: true }
                      });
                      $$payload6.out += `<!---->`;
                    },
                    $$slots: { default: true }
                  });
                }
                $$payload5.out += `<!--]--> `;
                Separator($$payload5, {});
                $$payload5.out += `<!----> `;
                Item($$payload5, {
                  href: "javascript:void(0)",
                  onclick: downloadInstaller,
                  children: ($$payload6) => {
                    Graphic($$payload6, {
                      class: "material-symbols-outlined",
                      children: ($$payload7) => {
                        $$payload7.out += `<!---->download`;
                      },
                      $$slots: { default: true }
                    });
                    $$payload6.out += `<!----> `;
                    Text($$payload6, {
                      children: ($$payload7) => {
                        $$payload7.out += `<!---->Download`;
                      },
                      $$slots: { default: true }
                    });
                    $$payload6.out += `<!---->`;
                  },
                  $$slots: { default: true }
                });
                $$payload5.out += `<!---->`;
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!----> `;
            PurchaseButton($$payload4, {
              containerClass: "mt-auto p-2",
              context: "drawer",
              menuClass: "z-[100]"
            });
            $$payload4.out += `<!---->`;
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!---->`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> `;
    Scrim($$payload2, { class: "z-[80]", fixed: true });
    $$payload2.out += `<!----> <div class="section-container flex items-center justify-center sticky top-0 z-50 bg-transparent !py-4 pointer-events-none"><div class="transition mx-auto text-white pointer-events-auto"><div${attr("class", `mx-auto ${stringify("bg-teal-950 text-white")} transition backdrop-blur-3xl p-4 px-8 rounded-3xl`)}><div class="flex items-center justify-between flex-row gap-4 lg:gap-12 min-w-48">`;
    Animate($$payload2, {
      children: ($$payload3) => {
        Logo($$payload3);
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="items-center gap-8 hidden lg:flex"><!--[-->`;
    for (let i = 0, $$length = each_array_1.length; i < $$length; i++) {
      let { name, link } = each_array_1[i];
      const active = store_get($$store_subs ??= {}, "$page", page).url.href.replace(store_get($$store_subs ??= {}, "$page", page).url.origin, "") === link;
      Animate($$payload2, {
        delay: (i + 1) * 0.1 + "s",
        children: ($$payload3) => {
          Link($$payload3, {
            to: link,
            class: active ? "!text-teal-300" : "",
            children: ($$payload4) => {
              $$payload4.out += `<!---->${escape_html(name)}`;
            },
            $$slots: { default: true }
          });
        },
        $$slots: { default: true }
      });
    }
    $$payload2.out += `<!--]--></div> <div class="flex lg:hidden cursor-pointer">`;
    IconButton($$payload2, {
      class: "material-symbols-outlined",
      onclick: () => open = true,
      children: ($$payload3) => {
        $$payload3.out += `<!---->menu`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div> <div class="hidden lg:flex">`;
    DownloadButton($$payload2, { size: 2 });
    $$payload2.out += `<!----></div></div></div></div></div>`;
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
function Footer($$payload, $$props) {
  push();
  const each_array = ensure_array_like(menu);
  $$payload.out += `<footer class="w-full py-12 md:py-24 bg-teal-950 text-white z-10 flex flex-col items-center"><div class="w-full lg:container mx-auto px-4 relative text-center flex flex-col gap-12"><div class="flex flex-col items-center gap-12 lg:gap-24 md:flex-row md:items-start justify-center mx-auto">`;
  Logo($$payload);
  $$payload.out += `<!----> <div class="flex gap-4 md:gap-8 lg:gap-12"><div class="flex flex-col items-start gap-4"><p class="font-display uppercase opacity-70 text-xs">Directory</p> <!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let { name, link } = each_array[i];
    Link($$payload, {
      to: link,
      children: ($$payload2) => {
        $$payload2.out += `<!---->${escape_html(name)}`;
      },
      $$slots: { default: true }
    });
  }
  $$payload.out += `<!--]--></div> <div class="flex flex-col items-start gap-4"><p class="font-display uppercase opacity-70 text-xs">Contact</p> `;
  Link($$payload, {
    to: "mailto:support@glimmr.app",
    children: ($$payload2) => {
      $$payload2.out += `<!---->Email us`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div></div> <div class="flex flex-col xl:flex-row gap-2">`;
  DownloadButton($$payload, { background: "dark", size: 4 });
  $$payload.out += `<!----> `;
  PurchaseButton($$payload, {
    background: "dark",
    context: "footer",
    size: 4
  });
  $$payload.out += `<!----></div></div> <div class="flex flex-col gap-4 items-center">`;
  Link($$payload, {
    to: "/privacy",
    children: ($$payload2) => {
      $$payload2.out += `<!---->Privacy Policy`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> <p class="font-display opacity-70">© ${escape_html((/* @__PURE__ */ new Date()).getFullYear())} Glimmr LLC / All rights reserved.</p></div></div></footer>`;
  pop();
}
function _layout($$payload, $$props) {
  AppContent($$payload, {
    class: "w-full h-full",
    children: ($$payload2) => {
      $$payload2.out += `<div class="fade-in bg-white">`;
      Navbar($$payload2);
      $$payload2.out += `<!----> <!---->`;
      slot($$payload2, $$props, "default", {});
      $$payload2.out += `<!----> `;
      Footer($$payload2);
      $$payload2.out += `<!----></div>`;
    },
    $$slots: { default: true }
  });
}
export {
  _layout as default
};
